import { ArrowRight, Link2 } from "lucide-react";
import type { HiringLoopStep } from "./demoHubConfig";

type HiringLoopSectionProps = {
  steps: HiringLoopStep[];
};

export function HiringLoopSection({ steps }: HiringLoopSectionProps) {
  return (
    <section className="border-y border-slate-200 bg-slate-950 py-20 text-slate-100 sm:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-[0.36fr_0.64fr] lg:items-start">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-2 border border-slate-700 bg-slate-900 px-3 py-1.5 text-xs font-bold uppercase tracking-[0.16em] text-amber-200">
              <Link2 className="h-3.5 w-3.5" aria-hidden="true" />
              theRecruit + theResume
            </span>
            <h2 className="mt-6 font-space-grotesk text-3xl font-bold leading-tight text-slate-50 sm:text-4xl">
              One connected hiring loop
            </h2>
            <p className="mt-5 text-base leading-7 text-slate-300">
              theRecruit is not just an ATS and not just resume screening. It is an AI hiring
              intelligence layer that helps recruiters move from resumes to interviews to
              evidence-backed decisions.
            </p>
          </div>

          <ol className="grid gap-px overflow-hidden border border-slate-800 bg-slate-800 md:grid-cols-5">
            {steps.map((step, index) => (
              <li key={step.title} className="relative bg-slate-950 p-5 md:min-h-[260px]">
                <div className="flex items-center justify-between">
                  <span className="flex h-9 w-9 items-center justify-center border border-slate-700 bg-slate-900 font-mono text-sm font-bold text-amber-200">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  {index < steps.length - 1 ? (
                    <ArrowRight
                      className="hidden h-4 w-4 text-slate-600 md:block"
                      aria-hidden="true"
                    />
                  ) : null}
                </div>
                <h3 className="mt-6 font-space-grotesk text-xl font-semibold leading-tight text-slate-50">
                  {step.title}
                </h3>
                <p className="mt-4 text-sm leading-6 text-slate-400">{step.text}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
